/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TechScreenTabletVIcon32Regular = forwardRef('TechScreenTabletVIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { d: "M10 23a1 1 0 1 0 0 2h12a1 1 0 1 0 0-2H10Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.5 2A5.5 5.5 0 0 0 4 7.5v17A5.5 5.5 0 0 0 9.5 30h13a5.5 5.5 0 0 0 5.5-5.5v-17A5.5 5.5 0 0 0 22.5 2h-13ZM6 7.5A3.5 3.5 0 0 1 9.5 4h13A3.5 3.5 0 0 1 26 7.5v17a3.5 3.5 0 0 1-3.5 3.5h-13A3.5 3.5 0 0 1 6 24.5v-17Z" })));
});
